import { render, staticRenderFns } from "./EmployeeAutocompleteInput.vue?vue&type=template&id=38a858bc&scoped=true"
import script from "./EmployeeAutocompleteInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeAutocompleteInput.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a858bc",
  null
  
)

export default component.exports